import React from 'react'

const Manual_inventario_ajuste_subreceta = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Inventario - Ajuste de Subreceta
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Esta guía detalla un proceso simple para crear Ajustes de Subreceta en la gestión de inventario, asegurando un seguimiento eficiente de la producción. Incluye pasos esenciales como la introducción de descripción, fecha y estado, junto con la posibilidad de añadir notas y seleccionar productos. Siguiendo esta guía, los usuarios pueden mejorar la precisión de sus ajustes de producción y mantener registros claros para un control óptimo del inventario.
        </p>
        <iframe
          src="https://scribehow.com/embed/Inventario__Ajuste_de_Subreceta__e9SeG9VHQPygxeVyvKWkvw?as=scrollable"
          className="scribe-iframe-general-41"
          width="100%"
          height="4700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_inventario_ajuste_subreceta